import React from "react";
import { TextField } from "@mui/material";
import { Field } from "formik";

export const IntegerFieldType = ({
  config,
  formik,
  setErrorState,
  stepNumber,
}: {
  config: any;
  formik: any;
  setErrorState: any;
  stepNumber: any;
}) => {
  const numbersOnly = /^[0-9]+$/;

  React.useEffect(() => {
    if (
      localStorage.copyValues === "true" &&
      localStorage.firstCameraAdded === "false" &&
      stepNumber === 1
    ) {
      const values = JSON.parse(localStorage.copiedValues);
      formik.values.http = values.http;
      formik.values.rtsp = values.rtsp;
    }
    if (config.validation) {
      setErrorState((previousState: any) => {
        return { ...previousState, [config.id]: true };
      });
    }
  }, []);

  return (
    <div key={config.id}>
      <Field
        error={
          formik.values[config.field] &&
          !numbersOnly.test(formik.values[config.field])
        }
        id={config.id}
        name={config.field}
        label={config.label}
        placeholder={config.label}
        autoComplete="off"
        variant="standard"
        sx={{ width: 350 }}
        helperText={
          formik.values[config.field] &&
          !numbersOnly.test(formik.values[config.field])
            ? "Must be a number"
            : config.helperText
        }
        as={NumberComponent}
      />
    </div>
  );
};

const NumberComponent = (props: any) => <TextField {...props} />;
